import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { actionCreators } from 'react/api/actions/photoGallery';
import * as selectors from 'react/api/selectors/photoGallery';

class PhotoGallery extends React.Component {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
    this.state = {
      largeImageEvent: {}
    };
  }

  componentDidUpdate() {
    const { largeImageEvent: { detail: { index } = {} } = {} } = this.state;
    const { photoAlbum, isCurrentPhotoLoading, currentPhoto } = this.props;

    if (this.viewer?.viewer && photoAlbum?.size) {
      if (isCurrentPhotoLoading) {
        this.viewer.viewer.classList.add('viewer-loading');
      } else if (currentPhoto?.get('base64Image') && this.viewer.viewer.classList.contains('viewer-loading')) {
        this.viewer.viewer.classList.remove('viewer-loading');
        this.viewer.update();
        this.viewer.view(index);
      }
    }
  }

  componentWillUnmount() {
    const { resetStateAction } = this.props;
    resetStateAction();
    this.setState({ largeImageEvent: {} });
    this.viewer?.destroy(); // eslint-disable-line no-unused-expressions
    delete this.viewer;
  }

  showViewer = (index) => {
    const { photoAlbum, setCurrentPhotoIdAction } = this.props;
    this.viewer = new window.Viewer(this.containerRef.current, {
      view: (viewerEvent) => {
        if (photoAlbum?.size) {
          const photoId = viewerEvent.detail.originalImage.getAttribute('photo-id');
          setCurrentPhotoIdAction(photoId);
          this.setState({ largeImageEvent: viewerEvent });
        }
      },
      hidden: () => {
        if (photoAlbum?.size) {
          setCurrentPhotoIdAction(null);
          this.setState({ largeImageEvent: {} });
        }
        this.viewer.destroy();
        delete this.viewer;
      },
      toolbar: {
        play: false,
        oneToOne: false,
        flipHorizontal: false,
        flipVertical: false,
        reset: { show: true, size: 'large' },
        rotateLeft: { show: true, size: 'large' },
        rotateRight: { show: true, size: 'large' },
        prev: { show: true, size: 'large' },
        next: { show: true, size: 'large' },
        zoomOut: { show: true, size: 'large' },
        zoomIn: { show: true, size: 'large' },
        deleteDisabled: { show: true, size: 'large' }
      },
      title: () => this.viewer.images[this.viewer.index].photoComment || ''
    });
    this.viewer.view(index);
  };

  renderPhotoAlbumThumbnails = () => {
    const { photoAlbum, largePhotos } = this.props;
    return photoAlbum?.size && (
      photoAlbum.map((thumbnail, index) => (
        <img
          data-testid={`thumb-${thumbnail.get('id')}`}
          key={`thumb${thumbnail.get('id')}`}
          className="photo-gallery__thumb"
          src={`data:image/png;base64,${largePhotos?.getIn([`${thumbnail.get('id')}`, 'base64Image'], thumbnail.get('base64Thumbnail'))}`}
          photo-id={thumbnail.get('id')}
          onClick={() => this.showViewer(index)}
        />
      ))
    );
  }

  renderSignatureThumbnail = () => {
    const { signaturePhoto } = this.props;
    return signaturePhoto?.get('base64Image') && (
      <img
        data-testid="signature-photo"
        className="photo-gallery__thumb photo-gallery__thumb-signature"
        src={`data:image/png;base64,${signaturePhoto.get('base64Image')}`}
        onClick={this.showViewer}
      />
    );
  }

  render() {
    const { photoAlbum } = this.props;
    return (
      <div data-testid="photo-gallery" className="photo-gallery" ref={this.containerRef}>
        {photoAlbum?.size ? this.renderPhotoAlbumThumbnails() : this.renderSignatureThumbnail() }
      </div>
    );
  }
}

PhotoGallery.propTypes = {
  // state
  photoAlbum: PropTypes.object,
  signaturePhoto: PropTypes.object,
  largePhotos: PropTypes.object.isRequired,
  currentPhoto: PropTypes.object,
  isCurrentPhotoLoading: PropTypes.bool.isRequired,
  // actions
  setCurrentPhotoIdAction: PropTypes.func.isRequired,
  resetStateAction: PropTypes.func.isRequired
};

PhotoGallery.defaultProps = {
  photoAlbum: null,
  signaturePhoto: null,
  currentPhoto: null
};

const mapStateToProps = (state) => ({
  largePhotos: selectors.getLargePhotos(state),
  currentPhoto: selectors.getCurrentPhoto(state),
  isCurrentPhotoLoading: selectors.getIsCurrentPhotoLoading(state)
});

const mapDispatchToProps = {
  setCurrentPhotoIdAction: actionCreators.setCurrentPhotoId,
  resetStateAction: actionCreators.resetState
};

export default connect(mapStateToProps, mapDispatchToProps)(PhotoGallery);
